<div *ngIf="opened" [attr.role]="role" [attr.aria-live]="ariaLive">
	<ng-content></ng-content>
</div>
